import React, { SVGProps } from 'react'

export const SolidDownArrowIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width='22'
      height='20'
      viewBox='0 0 22 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <g filter='url(#filter0_d_23944_206902)'>
        <path
          d='M5.63504 3.5C4.7872 3.5 4.32405 4.48886 4.86682 5.14018L10.2318 11.5781C10.6316 12.0579 11.3684 12.0579 11.7682 11.5781L17.1332 5.14019C17.676 4.48886 17.2128 3.5 16.365 3.5H5.63504Z'
          fill='currentColor'
        />
      </g>
      <defs>
        <filter
          id='filter0_d_23944_206902'
          x='0.632812'
          y='3.5'
          width='20.7344'
          height='16.4375'
          filterUnits='userSpaceOnUse'
          color-interpolation-filters='sRGB'
        >
          <feFlood flood-opacity='0' result='BackgroundImageFix' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy='4' />
          <feGaussianBlur stdDeviation='2' />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0'
          />
          <feBlend
            mode='normal'
            in2='BackgroundImageFix'
            result='effect1_dropShadow_23944_206902'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect1_dropShadow_23944_206902'
            result='shape'
          />
        </filter>
      </defs>
    </svg>
  )
}
